import { Swiper } from "swiper/react";

const MusicCardCourselSkeleton = () => {
  const arr = [1, 2, 3, 4, 5];
  return (
    <div className="mt-10">
      <div className="">
        <Swiper
          slidesPerView={4}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            370: {
              slidesPerView: 2,
            },
            700: {
              slidesPerView: 3,
            },
            1000: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
            1400: {
              slidesPerView: 4,
            },
            1600: {
              slidesPerView: 5,
            },
          }}
          className="mt-4 mb-5 mySwiper mx-auto"
        >
          <div className="flex flex-row lg:gap-[20px] sm:gap-[20px]">
            {arr.map((item: any) => (
              <div key={item} className="flex flex-col justify-center items-start">
                <div className="lg:w-[200px] h-[250px] bg-[#1a1919] animate-pulse mt-2"></div>
              </div>
            ))}
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default MusicCardCourselSkeleton;
